<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-unclassified-messages-existing-intent">
    <div class="assign-unclassified-msg-to-intent-header" v-if="controller.clonedMessages && controller.clonedMessages.length>0">
      <div class="assign-unclassified-msg-to-intent-title-flex" >
        <div class="flex-container">
          <img @click="controller.handlePageModalClose()" class="back-arrow" src="../../assets/icons/icon_assign_to_existing_back.svg" alt="">
          <span>Assign unclassified message to existing intent</span> 
        </div>
        <img class="close-icon" @click="controller.handlePageModalClose()" src="../../assets/icons/icon_transcript_close.svg" alt="">
      </div> 

      <!-- <a @click="controller.$refs.existingIntentsPopover.doClose()" class="pop-close-icon">&times;</a> -->

      <el-row class='assign-unclassified-msg-to-intent-button-row'>
        <div class="div-search-input">
          <div class="search-button material-icons">search</div>
          <el-input
            ref="searchExistedIntent"
            class="search-inp"
            placeholder="Search unclassified messages"
            v-model="searchKeyword"
            @focus="onSearchFocus"
            @blur="onSearchBlur"
            @keypress.enter.native="applySearch"
          ></el-input><i v-if="searchKeyword!=''" class="fas fa-times-circle" @click="clearSearchInput"></i>
        </div>
        <el-button v-if="controller.enableSuggestedIntents" plain class="selected-button" @click="controller.handleAssignToSuggestedIntents(controller.clonedMessages)">
          Assign selected items to suggested intents
        </el-button>
        <el-popover
          ref="existedIntentPopOver"
          placement="bottom"
          @show="suggestedIntentShow"
          width="400"
          trigger="click"
          popper-class="existed-intent-list">
          <div class="div-search-input">
            <div class="search-button material-icons">search</div>
              <el-input
                ref="searchSuggestedIntent"
                class="search-inp"
                placeholder="Search intents"
                v-model="searchIntentKeyword"
                @focus="onSearchFocus"
                @blur="onSearchBlur">
              </el-input><i v-if="searchIntentKeyword!=''" class="fas fa-times-circle" @click="clearSearchIntentInput"></i>
          </div>
          <div>
            <div v-if="filteredIntents.length>0" class="intent-list-section">
              <div class="intent-item" v-for="(intent,index) in filteredIntents" :key="index" @click="handleSelectIntent(intent)"> 
                {{intent}} 
              </div>
            </div>
            <div v-else class="no-search-result">
              No items match your search.
            </div>
            <!-- <div class="load-more-section">
              <el-button class="load-more-btn" slot="reference">Load more...</el-button>
            </div> -->
          </div>
          
          <!-- <el-button slot="reference">Assign selected items to one intent</el-button> -->
          <el-button ref="intentPopoverBtn" class="intent-popover-btn" slot="reference">
            <span class="text">Assign selected items to one intent</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-popover>
        <!-- <el-dropdown trigger="click" @command="(intent) => {controller.clonedMessages.filter(el=> el.selected).map(el => el.assignedIntent=intent)}">
          <el-button plain class="selected-button">
            Assign selected items to one intent<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu trigger="click" class="assign-items-to-one-intent-dropdown" slot="dropdown">
            <div class="ignore-wrap-div" v-for="(intent, index) in controller.intentList" :key="index" @mouseover="controller.mouseover($event, intent, 'fixed')" @mouseout="controller.mouseout">
              <el-dropdown-item :class="{'intent-dropdown-select': controller.selectedIntent == intent}" @click.native="controller.handleSelectIntent(intent)" :key="index" :command="intent">{{intent}}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown> -->
      </el-row>
    </div>

    <table class="assign-unclassified-msg-to-intent-table" >
      <thead>
        <tr class="table-titles">
          <div class="table-flex-container head-container">
            <td :class="{'unclassified-msg': true, 'disabled-suggested-intent': !controller.enableSuggestedIntents}">Unclassified message</td>
            <td v-if="controller.enableSuggestedIntents" class="suggested-intent">Suggested intent</td>
            <td v-if="controller.enableSuggestedIntents" class="classifier-prob">Classifier probability </td>
            <td class="assigned-intent">Assigned intent</td>
          </div>
        </tr>
      </thead>
      <tbody>
      <div class="table-boday-container" v-if="filtedMessages.length > 0">
        <div class="table-flex-container">
          <tr>
            <div :class="{'unclassified-msg': true, 'disabled-suggested-intent': !controller.enableSuggestedIntents}"><el-checkbox  v-model="selectedAll" :indeterminate="selectedIsIndeterminate" @change="selectedAllChanged" class="unclassified-msg-checkbox">All</el-checkbox></div>
            <div v-if="controller.enableSuggestedIntents" class="suggested-intent"></div>
            <div v-if="controller.enableSuggestedIntents" class="classifier-prob"></div>
            <div class="assigned-intent"></div>
          </tr>
        </div>
        <div class="table-flex-container table-body">
          <tr v-for="(item, index) in filtedMessages" :key="index">
          
            <div :class="{'unclassified-msg': true, 'disabled-suggested-intent': !controller.enableSuggestedIntents}">
              <el-checkbox @change="handleCheckboxChange" v-model="item.selected" class="unclassified-msg-checkbox">
                <div class="ellipsis" @mouseover="controller.mouseover($event, item.message, 'fixed')" @mouseout="controller.mouseout">{{item.message}}</div>
              </el-checkbox>
            </div>
            <div v-if="controller.enableSuggestedIntents" class="suggested-intent">
              <div class="ellipsis" @mouseover="controller.mouseover($event, item.suggestedIntent, 'fixed')" @mouseout="controller.mouseout">
                {{item.suggestedIntent}}
              </div>
            </div>
            <div v-if="controller.enableSuggestedIntents" class="classifier-prob">
              <!-- <div class="ellipsis" @mouseover="mouseover($event, `Total: ${item.total}`, 'fixed')" @mouseout="mouseout"> -->
                {{Math.round(item.classifierProbability * 100)}}%
              <!-- </div> -->
            </div>
            <div class="assigned-intent" @mouseover="controller.mouseover($event, item.assignedIntent, 'fixed')" @mouseout="controller.mouseout">
              <el-select
                v-model="item.assignedIntent"
                collapse-tags
                size="mini"
                @visible-change="visibleChange($event, item)"
                @blur="removeIntentList(item)"
                style="margin-left: 5px;"
                popper-class="assign-unclassified-msg-to-intent-dropdown"
                placement="bottom">

                <el-option-group v-if="controller.enableSuggestedIntents" label="Suggested intent">
                  <div @mouseover="controller.mouseover($event, item.suggestedIntent, 'fixed')" @mouseout="controller.mouseout">
                    <el-option :label="item.suggestedIntent" :value="item.suggestedIntent"></el-option>
                  </div>
                </el-option-group>
                <el-option-group label="Select intent" v-if="item.intentList">
                  <!-- <div v-for="(intent) in localIntentListObj[index]" :key="intent" @mouseover="controller.mouseover($event, intent, 'fixed')" @mouseout="controller.mouseout"> -->
                  <div v-for="(intent) in item.intentList.filter(el => el!=item.suggestedIntent)" :key="intent" @mouseover="controller.mouseover($event, intent, 'fixed')" @mouseout="controller.mouseout">
                    <el-option
                      placement="bottom"
                      :key="intent"
                      :label="intent"
                      :value="intent">
                    </el-option>
                  </div>
                </el-option-group>
              </el-select>
            </div>
          </tr>
        </div>
      </div>
      <div v-else class="no-search-result">
        No items match your search.
      </div>
      </tbody>
    </table>

    <div class="intent-action-popup-bottom-flex">
      <div class="intent-action-dropdown-cancel-btn" @click="controller.handlePageModalClose()">Cancel</div>
      <button class="intent-action-dropdown-save-btn" :disabled="!enableSaveButton" @click="controller.handleExitingIntentsSave">Save selected items</button>
    </div>
    <div class="overlay-intent" ref="overlayIntent" @click="handleCloseIntentPopOver"></div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-va-optimization-unclassified-messages-existing-intent',
  props: ["controller"],

  data() {
    return {
      searchKeywordInput: '',
      searchKeyword: '',
      searchIntentKeyword: '',
      selectedIsIndeterminate: false,
      selectedAll: false,
      popOverLeft: '318px',
      localIntentListObj: {},
    }
  },

  computed: {
    enableSaveButton() {
      return this.controller.clonedMessages.filter(item => item.selected).filter(item => item.assignedIntent).length > 0
    },
    filtedMessages() {
      return this.controller.clonedMessages ? this.controller.clonedMessages.filter(item=>{ return item.message.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()) }) : [];
    },
    filteredIntents() {
      return this.controller.intentList ? this.controller.intentList.filter(item=>{ return item.toLowerCase().includes(this.searchIntentKeyword.trim().toLowerCase()) }) : [];
    }
  },

  methods: {
    handleCheckboxChange(){
      let selected = 0
      this.filtedMessages.forEach(el => {
        if(el.selected) {
          selected += 1;
        }
      })
      if(selected > 0 && selected < this.filtedMessages.length){
        this.selectedIsIndeterminate = true;
        this.selectedAll = false;
      } 
      else {
        if(selected == this.filtedMessages.length) {
          this.selectedAll = true;
          this.selectedIsIndeterminate = false;
        }
        else {
          this.selectedAll = false;
          this.selectedIsIndeterminate = false;
        }
      }
    },

    selectedAllChanged(isChecked) {
      this.filtedMessages.map(el => el.selected=isChecked);
      this.handleCheckboxChange();
    },
    onSearchFocus() {

    },

    onSearchBlur() {

    },

    clearSearchInput() {
      this.searchKeywordInput = '';
      this.applySearch()
    },

    clearSearchIntentInput() {
      this.searchIntentKeyword = '';
    },

    applySearch() {
      this.searchKeyword = this.searchKeywordInput;
      setTimeout(() => {
        this.handleCheckboxChange()
      }, 500);
    },

    suggestedIntentShow() {
      this.$refs.intentPopoverBtn.$el.classList.add('get-focus')
      this.$refs.intentPopoverBtn.$el.firstElementChild.lastElementChild.classList.add('el-icon-arrow-up')
      this.$refs.intentPopoverBtn.$el.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-down')
      this.$refs.overlayIntent.style.display = "block";
    },
    handleCloseIntentPopOver() {
      this.$refs.intentPopoverBtn.$el.classList.remove('get-focus')
      this.$refs.intentPopoverBtn.$el.firstElementChild.lastElementChild.classList.add('el-icon-arrow-down')
      this.$refs.intentPopoverBtn.$el.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-up')
      this.$refs.overlayIntent.style.display = "none";
      this.$refs.existedIntentPopOver.doClose();
    },
    

    handleSelectIntent(intent){
      this.controller.assignToOneIntent = true;
      this.controller.assignToSuggestedIntents = false;
      this.controller.clonedMessages.filter(el=> el.selected).map(el => el.assignedIntent=intent);
      this.handleCloseIntentPopOver()
      // this.$refs.existedIntentPopOver.doClose();
    },

    visibleChange(open, item) {
      if(open) {
        this.setIntentList(item);
      }
    },

    setIntentList(item) {
      item.intentList = this.controller.intentList.filter(el => el!=item.suggestedIntent)
    },
    removeIntentList(item) {
      setTimeout(() => {
        item.intentList = null
      }, 100);
    }
  },
  created() {
    this.handleCheckboxChange();
  }
})

</script>


<style lang="scss">
  .wy-va-optimization-unclassified-messages-existing-intent {
    width: calc(100% - 46px)!important;
    height: calc(100% - 43px);
    overflow-y: hidden;
    border-radius: 8px;
    padding: 23px;
    border: 1px solid #CAD2DA;
    min-height: 743px;
    .unclassified-msg-checkbox {
      margin-left: 2px !important;
    }
    img.back-arrow {
      margin-right: 23px;
      cursor: pointer;
    }
    .close-icon{
      cursor: pointer;
    }
    .assign-unclassified-msg-to-intent-title-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 11px;
    }
    .flex-container {
      display: flex;
      margin-left: 19px;
    }

    .el-input__icon {
      height: unset;
    }

    .el-select .el-input__inner:focus {
      border-color: #828E9A !important;
    }
    
    .el-select {
      margin-left: 0px !important;

      .el-input__inner{
        font-size: 14.22px !important;
      }
    }
    td.unclassified-msg {
      width: 370px !important;
    }
    td.suggested-intent {
      width: 238px !important;
    }
    .el-select .el-input .el-select__caret {
      color: #606060 !important;
      font-size: 14px !important;
      position: relative;
      right: -1px;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:focus{
      // color: #106FBC !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
    }

    .el-select:hover, .el-select:focus {
      .el-input__inner {
        border-color: #106FBC !important;
      }
      .el-select__caret {
        color: #106FBC !important;
      }    
    }

    .existing-intent-popover-header {
      color: #828E9A !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14.22px;
      padding: 20px 15px 10px 15px !important;
    }

    .intent-action-dropdown-cancel-btn {
      color: var(--site-button-cancel-btn-primary-color);
      border: 1px solid var(--site-button-cancel-btn-primary-border-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-weight: 400;
      padding: 8px 16px 8px 16px;
      display: flex;
      border-radius: 5px;
      height: fit-content;
      width: fit-content;
      cursor: pointer;
      background-color: transparent;
      margin-right: 15px;
      align-items: center;
      justify-content: center;
    }

    .intent-action-dropdown-save-btn {
      width: fit-content;
      height: fit-content;
      padding: 8px 16px 8px 16px;
      font-size: 15px;
      cursor: pointer;
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color) !important;
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      border-radius: 5px;
      margin-right: 15px;
      align-items: center;
      justify-content: center;
    }
    .intent-action-dropdown-save-btn:hover {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:active {
      background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:focus {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .intent-action-dropdown-save-btn:disabled {
      background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
      cursor: not-allowed;
    }

    .intent-action-popup-bottom-flex {
      display: flex;
      justify-content: flex-end;
      padding-top: 13px;
      margin-top: 13px;
      border-top: 1px solid #CAD2DA;
      width: 100%;
      padding-bottom: 11px !important;
    }

    .existing-intent-popover-item {
      width: 100%;
      font-size: 14.22px;
      position: inherit;
      > div {
        color: var(--site-font-tertiary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14.22px;
        padding: 10px 15px !important;
        cursor: pointer;
        width: fit-content;
        max-width: 309px;
        text-align: left;
        top: 5px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-select.el-select--mini {
        position: inherit;
        width: 100%;
        .el-input.el-input--mini.el-input--suffix {
          position: inherit;
        }
        .el-input__inner {
          padding-left: 0px;
          width: 100%;
          max-width: 309px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .el-input__suffix {
          position: relative;
        }
      }
    }
    .existing-intent-popover-title {
      color: var(--site-font-tertiary-color) !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      display: flex;
      font-size: 16px;
      padding: 8px 15px !important;
      border-bottom: 1px solid #CAD2DA;
      justify-content: space-between;
      align-items: center;
      a.pop-close-icon {
        font-size: 35px;
        color: #5C5F62;
        cursor: pointer;
        position: relative;
        bottom: 3px;
        font-weight: 200;
        float: right; 
      }

    }
    div.tooltips {
      display:block;
      position:absolute;
      padding: 5px 10px;
      max-width: 300px;
      width: max-content;
      border-radius: 5px;
      white-space: pre-wrap;
      word-wrap: break-word;
      border: 1px solid #6e7044;
      background-color: #444444;
      color: #FFF;
      z-index: 999;
      line-height: 18px;
    }
    div.tooltips {
      font-size: 12px !important;
      font-weight: 500 !important;
      padding: 5px 10px !important;
      animation: fadeIn .5s;
      -webkit-animation: fadeIn .5s;
      -moz-animation: fadeIn .5s;
      -o-animation: fadeIn .5s;
      -ms-animation: fadeIn .5s;
    }
    div.tooltips.fadeOut {
      animation: fadeOut .5s;
      -webkit-animation: fadeOut .5s;
      -moz-animation: fadeOut .5s;
      -o-animation: fadeOut .5s;
      -ms-animation: fadeOut .5s;
    }
    @keyframes fadeIn {
      0% { opacity: 0; }
      100% { opacity: 1; }
    }
    @keyframes fadeOut {
      0% { opacity: 1; }
      100% { opacity: 0; }
    }

    

    .assign-unclassified-msg-to-intent-dropdown {
      .el-select-dropdown__item.selected{
        background: #E8F1FF;
        color: #1C4DB2;
        font-weight: 400;
      }
      .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
        background-color: #F4F6F8;
      }
    }
    
    .assign-unclassified-msg-to-intent-bottom-flex{
      display: flex;
      justify-content: space-between;
      padding-top: 22px;
      margin-top: 20px;
      border-top: 1px solid #CAD2DA;
      width: 1069px;
      position: fixed;
      bottom: 27px;
    }

    .assign-unclassified-msg-to-intent-header{
      color: var(--site-font-tertiary-color) !important;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 18px;
      border-bottom: 1px solid #CAD2DA;
      font-weight: 500;
      a.pop-close-icon {
        font-size: 35px;
        color: #5C5F62;
        cursor: pointer;
        position: relative;
        bottom: 15px;
        font-weight: 200;
        float: right; 
      }
    }

    .assign-unclassified-msg-to-intent-button-row.el-row {
      margin-bottom: 5px;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      padding-top: 5px;
      .el-button{
        padding: 10px 20px !important;
        // margin-right: 15px;
        color: var(--site-font-tertiary-color);
        font-weight: 400 !important;
        font-size: 16px;
        position: relative;
        // left: 240px;
        border: 1px solid #DCDFE6;
        margin-top: 16px;
        margin-right: 10px;
        float: right;
      }
      // .assigned-to-one-intent-style {
      //   border: 1px solid #106FBC;
      //   background: #FFF;
      // }
      .el-button.intent-popover-btn:focus, .el-button.intent-popover-btn:hover {
        border: 1px solid #DCDFE6;
        background-color: #FFF;
      }
      .el-button.intent-popover-btn.get-focus {
        border-color:  #106FBC;
        background-color: #FFF;
      }
      .el-button.intent-popover-btn {
        .el-icon--right {
          margin-left: 10px;
          font-size: 12px;
        }
        .el-icon--right.el-icon-arrow-up {
          color: #106FBC;
        }
      }
      .el-button.is-plain:hover {
        // background: #F4F6F8;
        // border-color: #CAD2DA;
        color: var(--site-font-tertiary-color);
      }
      .el-input.is-focus .el-input__inner {
        // border-color: #DCDFE6 !important;
        border-color: #106FBC !important;
      }
      .el-input__inner:focus {
        // border-color: #DCDFE6 !important;
        border-color: #106FBC !important;
      }
      .el-input--mini .el-input__inner {
        height: 28px;
        line-height: 28px;
        width: fit-content;
        max-width: 309px;
        text-align: left;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .div-search-input {
        width: calc(100% - 721px);
        max-width: 575px;
        height: 40px;
        display: inline-block;
        position: relative;
        border: unset;
        margin-right: 1px;
        padding-left: 10px;
        .search-button {
          background-color: white;
          border-radius: 8px;
          width: 38px;
          height: 23px;
          text-align: center;
          margin-top: 5px;
          margin-left: 6px;
          padding: 4px 0px 0px 0px;
          font-size: 22px;
          position: absolute;
          z-index: 100;
          background: transparent;
          color: #5C5F62;
          cursor: pointer;
        }
        input.el-input__inner {
          border-width: 1px !important;
          height: 38px;
          border-radius: 20px;
          border: 1px solid #CAD2DA;
          font-size: 15px;
          padding-left: 45px;
          padding-right: 30px;
          padding-bottom: 0px;
          width: 100%;
        }
        .el-input__icon {
          line-height: 25px;
          font-weight: bolder;
          background-image: url('../../assets/icons/icon_search.svg');
          background-repeat: no-repeat;
          background-size: 16px 16px;
          background-position-y: 8px;
          background-position-x: 5px;
        }
        .el-input__icon:before {
          content: '';
        }
        .el-input{
          border: 0px;
          font-size: 14px;
          width: inherit;
          height: 38px;
          // padding-left: 10px;
          padding-bottom: 0px;
          width: 100%;
        }
        .fa-times-circle {
          position: relative;
          float: right;
          right: 5px;
          top: -27px;
          // bottom: -1px;
          color: #606060;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }



    .assign-unclassified-msg-to-intent-table{
      // width: 1071px;
      width: 100%;
      // height: calc(100% - 217px);
      tr {
        display: inline-flex;
        width: 100%;
      }
      tr div.unclassified-msg {
        display: inline-block;
        height: 20px;
        text-align: left;
        padding: 15px;
        width: 370px !important;
        max-width: 450px;
      }
      tr div.unclassified-msg.disabled-suggested-intent {
        width: 750px !important;
      }
      
      tr.table-titles td.unclassified-msg {
        padding-left: 35px !important;
      }
      .table-flex-container.table-body {
        height: calc(100vh - 445px);
        overflow-y: auto;
      }
      .table-flex-container.head-container {
        border-bottom: 1px #CAD2DA solid;
        width: 100%;
      }
      .table-titles {
        font-weight: 500;
        font-size: 14.5px;
      }
      .unclassified-msg-checkbox, .unclassified-msg-checkbox-checkbox-all {
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-check-color);
          border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
        }
        .el-checkbox__inner {
          width: 12px !important;
          height: 12px !important;
          border-radius: 3px !important;
          border: 1px solid var(--primary-checkbox-button-border-color) !important;
        }
        .el-checkbox__inner::after {
          left: 3px;
          top: 2px;
          height: 4px;
        }
      }
      .unclassified-msg-checkbox.is-checked, .unclassified-msg-checkbox-all.is-checked {
        .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-check-color);
          border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
        }
      }
      label.el-checkbox.unclassified-msg-checkbox {
        display: flex;
        align-items: center;
        width: inherit;
        span.el-checkbox__inner:hover {
          // box-shadow: unset !important;
          -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow)  !important;
          box-shadow: var(--primary-checkbox-button-hover-box-shadow) !important;
        }
      }
      .table-flex-container  .el-checkbox__input.is-checked+.el-checkbox__label {
        width: fit-content;
        //max-width: 216px;
        text-align: left;
        color: var(--site-font-secondary-color) !important;
        // top: 5px;
        position: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .table-flex-container .el-checkbox__label {
        width: fit-content;
        //max-width: 216px;
        text-align: left;
        color: var(--site-font-secondary-color) !important;
        // top: 5px;
        position: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .table-flex-container {
        .unclassified-msg-checkbox {
          position: inherit;
        }
      }
      span.el-checkbox__label {
        position: inherit;
        width: 100%;
        > div.ellipsis {
          font-weight: normal;
          width: fit-content;
          max-width: 100%;
          color: var(--site-font-secondary-color);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      
      div.assigned-intent {
        // width: 201px !important;
        // width: calc(100% - 975px);
        width: calc(100% - 650px);
        display: inline-block;
        height: 20px;
        text-align: left;
        padding: 15px;
        position: inherit;
        .el-select.el-select--mini {
          margin-left: 0px !important;
          position: inherit;
          width: 100%;
          .el-input.el-input--mini.el-input--suffix {
            position: inherit;
          }
          .el-input__inner {
            padding-left: 0px;
            width: 100%;
            // max-width: 309px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            background-color: transparent;
          }
          .el-input__suffix {
            position: relative;
            .el-input__suffix-inner {
              position: relative;
            }
          }
        }
        .el-select .el-input .el-select__caret {
          color: #C0C4CC;
          font-size: 10px;
          position: absolute;
        }
        .tooltips {
          width: max-content;
          // max-width: 400px;
          // right: -30px;
        }
      }
      td{
        width: 155px;
        height: 20px;
        text-align: left;
        padding: 15px;
        color: var(--site-font-secondary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14.22px;
      }
      div.classifier-prob{
        width: 184px !important;
        display: inline-block;
        text-align: center;
        height: 20px;
        padding: 15px;
      }
      div.suggested-intent{
        width: 238px !important;
        display: inline-block;
        height: 20px;
        text-align: left;
        padding: 15px;
        font-size: 14px;
        > div.ellipsis {
          width: 300px !important;
          max-width: 238px;
          text-align: left;
          color: var(--site-font-secondary-color);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
      }
      div.tooltips {
        display:block;
        position: fixed;
        padding: 5px 10px;
        max-width: 223px;
        width: max-content;
        border-radius: 5px;
        white-space: pre-wrap;
        word-wrap: break-word;
        border: 1px solid #6e7044;
        background-color: #444444;
        color: #FFF !important;
        z-index: 999;
        line-height: 18px;
      }
      .no-search-result {
        padding: 20px 0px 0px 28px;
        font-size: 15px;
      }
    }

    .table-boday-container {
      // height: 484px;
      height: 100%;
      // min-height: 450px;
      overflow: hidden;
      position: inherit;
      &::-webkit-scrollbar {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#FFFFFF;
      }
      &::-webkit-scrollbar:vertical {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
      }
    }
    .overlay-intent {
      display: none;
      background-color: transparent;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 999;
    }
  }

  .existed-intent-list {
    width: calc(100% - 400px) !important;
    left: 318px !important;
    padding: 20px 5px 0 0;
    height: auto;
    max-height: 580px;
    min-height: 260px;
    min-width: 616px;
    
    .div-search-input {
      width: 575px;
      height: 25px;
      display: inline-block;
      position: relative;
      margin-right: 1px;
      .search-button {
        background-color: white;
        border-radius: 8px;
        width: 38px;
        height: 23px;
        text-align: center;
        margin-top: -1px;
        margin-left: 9px;
        padding: 5px 0px 0px 0px;
        font-size: 22px;
        position: absolute;
        z-index: 100;
        background: transparent;
        color: #5C5F62;
        cursor: pointer;
      }
      input.el-input__inner {
        border-width: 1px !important;
        height: 30px;
        font-size: 15px;
        padding-left: 35px;
        padding-right: 30px;
        padding-bottom: 0px;
        border-radius: 5px;
        width: 575px;
      }
      input.el-input__inner:focus {
        border-color: #106FBC !important;
        background-color: #FFF !important;
      }
      input.el-input__inner:hover {
        background-color: #F4F6F8;
      }
      .el-input__icon {
        line-height: 25px;
        font-weight: bolder;
        background-image: url('../../assets/icons/icon_search.svg');
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position-y: 8px;
        background-position-x: 5px;
      }
      .el-input__icon:before {
        content: '';
      }
      .el-input{
        border: 0px;
        font-size: 14px;
        width: inherit;
        height: 25px;
        padding-left: 10px;
        padding-bottom: 0px;
        width: 100%;
      }
      .fa-times-circle {
        position: relative;
        left: 0px;
        bottom: 0px;
        top: -18px;
        float: right;
        color: #000000;
        font-size: 16px;
        cursor: pointer;
      }
    }

    .intent-list-section {
      max-height: 500px;
      margin-top: 15px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#FFFFFF;
      }
      &::-webkit-scrollbar:vertical {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
      }
      .intent-item {
        padding: 15px;
        cursor: pointer;
        font-size: 14.22px;
      }
      .intent-item:hover {
        background-color: #F4F6F8;
      }
      .intent-item:active {
        background-color: #E8F1FF;
        color: #106FBC;
      }
    }
    .load-more-section {
      width: 100%;
      text-align: center;
      .load-more-btn {

      }
    }

    .no-search-result {
      padding: 20px 0px 0px 10px;
      font-size: 12px;
    }
  }
  .existed-intent-list.minified-menu {
    left: 58px !important;
  }
  </style>